module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"book:title":"Справочник","book:load-more":"Загрузить еще","book:select-ds":"Для начала работы выберите источник данных в панели слева"},"en":{"book:title":"Book","book:load-more":"Load more","book:select-ds":"To get started, select a data source in the left pane"}}')
  delete Component.options._Ctor
}
